<template>
  <div>
    <div class="container">
      <h2 class="ml--1">
        {{ $t("ct-version-control") }}
      </h2>

      <div class="row">
        <div class="col-12">
          <div class="row pl-3">
            <span class="col-4">{{ $t("ct-version-date") }} </span>
            <span class="col-5">{{ $t("ct-rollback") }}</span>
            <span class="col-3 ml--1">{{ $t("ct-version-type") }}</span>
          </div>
        </div>
        <div
          v-for="(version, index) in versions"
          :key="index"
          class="card col-12 mt-3"
        >
          <div
            class="card-body row"
            :class="{ 'border-active': version.status }"
          >
            <span class="col-4 card-title">
              {{ moment(version.created_at).subtract(new Date().getTimezoneOffset(), "minutes").format("LLL") }}

            </span>
            <a
              href="#"
              @click="confirmRollback(version.id)"
              class="col-5 card-link"
            >
              <i class="svg-icon svgi-rollback"></i> {{ $t('ct-rollback-this-version')  }}
            </a>
            <span class="col-3" :class="{ 'text-active': version.status }">
              {{
                version.status
                  ? $t("ct-version-active")
                  : moment(version.created_at).subtract(new Date().getTimezoneOffset(), "minutes").fromNow()
              }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <modal-confirm-component
      :show="modalShow"
      :type="modalType"
      :text="modalText"
      @cancel="cancelRollback"
      @confirm="setVersion"
    ></modal-confirm-component>
  </div>
</template>

<script>
import {
  getVersions,
  setActiveVersion,
} from "../../../js/services/editor/page";
import moment from "moment";
import ModalConfirmComponent from "../components/ModalConfirm";

export default {
  components: { ModalConfirmComponent },
  data() {
    return {
      versions: [],
      modalShow: "",
      modalType: "",
      modalText: "",
      versionId: 0,
    };
  },
  methods: {
    moment: moment,

    setVersion() {
      setActiveVersion(
        this.$route.params.id,
        this.$route.params.page_id,
        this.versionId
      ).then((response) => {
        this.$snotify.success(this.$t("ct-version-changed-success"));
        this.loadVersions();
        this.modalShow = false;
      });
    },
    loadVersions() {
      this.versions = [];
      getVersions(this.$route.params.id, this.$route.params.page_id).then(
        (response) => {
          this.versions = response.data;
        }
      );
    },
    confirmRollback(id) {
      this.modalType = this.$t(`ct-rollback`);
      this.modalText = this.$t(`ct-confirm-rollback`);
      this.modalShow = true;
      this.versionId = id;
    },
    cancelRollback() {
      this.modalShow = false;
    },
  },
  mounted() {
    this.loadVersions();
    moment.locale(navigator.language);
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 30px;
  color: #0080fc;
  font-family: Muli;
  font-weight: bolder;
  margin-top: 25px;
}
.text-active {
  color: #01d4b9;
}

.border-active {
  border: 1px solid #01d4b9;
}

div.row.pl-3 {
  margin-top: 25px;
  color: #434343;
  font-family: "Lato";
  font-weight: bold;
}

.card-title {
  color: #8c8c8c;
}

.svg-icon {
  vertical-align: middle;
  margin-right: 5px;

  &:after {
    width: 18px;
    height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Versions.vue